var _defs, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIau(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_7",
    "data-name": "Layer 7",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 748.95 747.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#865c63;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5,154.3V306.68L156.26,155.41c83.38-83,151.27-151.63,151.27-152,0-.74-67.89-1.11-151.27-1.11H5Z",
    transform: "translate(-2.23 -2.3)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M188.54,188.62,2.23,374.93,189.65,562.36l187,187,187.06-187L751.18,374.93,564.86,188.62C462.3,86.05,377.81,2.3,376.7,2.3S291.11,86.05,188.54,188.62Z",
    transform: "translate(-2.23 -2.3)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M596.22,153.57c83,83,151.64,151.26,152,151.26.74,0,1.11-68.25,1.11-151.26V2.3H445Z",
    transform: "translate(-2.23 -2.3)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.07,596.3V747.56H308.45L157.18,596.3C74.17,512.92,5.55,445,5.18,445,4.44,445,4.07,512.92,4.07,596.3Z",
    transform: "translate(-2.23 -2.3)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M596.22,596.3,445,747.56H749.34V596.3c0-83.38-.37-151.27-1.11-151.27C747.86,445,679.24,512.92,596.22,596.3Z",
    transform: "translate(-2.23 -2.3)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIau);
export default __webpack_public_path__ + "static/media/iau.529c12f29dcb68c29835bf6b9d1ee6c2.svg";
export { ForwardRef as ReactComponent };